import React, { useState } from 'react'
import { useTenant } from '../contexts/TenantContext'
import { cancelarPromocoesPublico } from '../lib/supabase'

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export default function CancelarPromocoes() {
  const { tenant } = useTenant()
  const [email, setEmail] = useState('')
  const [estado, setEstado] = useState('idle') // idle | enviando | ok | erro
  const [msg, setMsg] = useState('')

  async function submeter(e) {
    e.preventDefault()
    if (!tenant) return
    if (!EMAIL_RE.test(email.trim())) {
      setEstado('erro')
      setMsg('Introduza um email válido.')
      return
    }
    setEstado('enviando')
    try {
      const n = await cancelarPromocoesPublico(tenant.id, email.trim())
      setEstado('ok')
      setMsg(n > 0
        ? 'Pronto! Deixou de receber comunicações de promoções.'
        : 'Se este email estiver na nossa lista, deixou de receber promoções.')
    } catch {
      setEstado('erro')
      setMsg('Não foi possível processar o pedido. Tente novamente mais tarde.')
    }
  }

  return (
    <main style={{ maxWidth: '460px', margin: '64px auto', padding: '0 24px' }}>
      <div style={{ background: 'var(--cor-branco)', border: '1px solid var(--cor-borda)', borderRadius: 'var(--raio-lg)', padding: '32px', boxShadow: 'var(--sombra)' }}>
        <h1 style={{ fontSize: '22px', marginBottom: '8px' }}>Cancelar subscrição</h1>
        <p style={{ color: 'var(--cor-texto-suave)', fontSize: '14px', marginBottom: '24px', lineHeight: 1.5 }}>
          Indique o seu email para deixar de receber comunicações de promoções
          {tenant?.nome ? ` de ${tenant.nome}` : ''}.
        </p>

        {estado === 'ok' ? (
          <p style={{ color: '#16A34A', fontSize: '14px', lineHeight: 1.5 }}>{msg}</p>
        ) : (
          <form onSubmit={submeter}>
            <input
              type="email" required value={email} onChange={e => setEmail(e.target.value)}
              placeholder="o.seu@email.com"
              style={{ width: '100%', padding: '10px 12px', border: '1px solid var(--cor-borda)', borderRadius: 'var(--raio)', fontSize: '14px', boxSizing: 'border-box', marginBottom: '14px' }}
            />
            {estado === 'erro' && <p style={{ color: '#c0392b', fontSize: '13px', marginBottom: '12px' }}>{msg}</p>}
            <button type="submit" className="btn-primario" disabled={estado === 'enviando'} style={{ width: '100%', justifyContent: 'center', opacity: estado === 'enviando' ? 0.6 : 1 }}>
              {estado === 'enviando' ? 'A processar…' : 'Cancelar subscrição'}
            </button>
          </form>
        )}
      </div>
    </main>
  )
}
